import { useQuery } from "@tanstack/react-query";

import { getFarmVerificationSummary } from "services";

import { FARM_VERIFICATION_SUMMARY } from "consts";

interface UseGetFarmVerificationSummaryOptions {
  farmId: string;
  refetchInterval?: number | false;
}

export const useGetFarmVerificationSummary = ({ farmId, refetchInterval = false }: UseGetFarmVerificationSummaryOptions) =>
  useQuery({
    queryKey: [FARM_VERIFICATION_SUMMARY, farmId],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await getFarmVerificationSummary({ farmId });
      const { farm, practices: _practices, ...summary } = response;
      return { farm, summary };
    },
    enabled: !!farmId,
    refetchInterval,
    staleTime: 5000, // Consider data fresh for 5 seconds
  });
